import React from 'react';
import * as Styles from './StudioPlansHandler.styles';
import withErrorBoundary from '@/utils/errorBoundary';
import { Skeleton } from 'gatorcomponents';
import { useResize } from '@/hooks/useResize';

const StudioPlansSkeleton = ({ loading }) => {
  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 960;

  if (loading) {
    return (
      <Styles.Container loading={loading} testId="container-loading">
        <Styles.WrapperSkeleton position="banner">
          <Skeleton variant="headline" width="440px" />
          <Skeleton variant="textLine" width="440px" />
          <Skeleton variant="textLine" width="440px" />
          <Skeleton variant="button" />
        </Styles.WrapperSkeleton>

        <Styles.ContentSkeleton>
          <Styles.WrapperSkeleton position="headers">
            <Styles.ColumnSkeleton type="desc">
              <Skeleton variant="paragraph" />

              <Styles.WrapperButtonSkeleton>
                <Styles.ButtonSkeletonItem>
                  <Skeleton variant="button" />
                </Styles.ButtonSkeletonItem>
                <Styles.ButtonSkeletonItem>
                  <Skeleton variant="button" />
                </Styles.ButtonSkeletonItem>
              </Styles.WrapperButtonSkeleton>
            </Styles.ColumnSkeleton>

            {!mobile && (
              <>
                <Styles.ColumnSkeleton type="plan">
                  <Skeleton variant="paragraph" />

                  <Styles.WrapperButtonSkeleton>
                    <Skeleton variant="button" />
                  </Styles.WrapperButtonSkeleton>
                </Styles.ColumnSkeleton>

                <Styles.ColumnSkeleton type="plan">
                  <Skeleton variant="paragraph" />

                  <Styles.WrapperButtonSkeleton>
                    <Skeleton variant="button" />
                  </Styles.WrapperButtonSkeleton>
                </Styles.ColumnSkeleton>
              </>
            )}
          </Styles.WrapperSkeleton>

          {!mobile && (
            <>
              <Styles.WrapperSkeleton position="table">
                {Array.from({ length: 8 }).map(() => (
                  <Styles.LineSkeleton />
                ))}
              </Styles.WrapperSkeleton>

              <Styles.WrapperSkeleton position="bottom">
                <Styles.ButtonSkeleton />
              </Styles.WrapperSkeleton>
            </>
          )}

          {mobile && (
            <Styles.WrapperSkeleton position="table">
              <Styles.ColumnSkeleton>
                <Skeleton variant="paragraph" />
                <Skeleton variant="button" />

                {Array.from({ length: 8 }).map(() => (
                  <Skeleton height="70px" variant="rectangle" width="400px" />
                ))}
                <Styles.WrapperSkeleton position="bottom">
                  <Skeleton variant="button" />
                </Styles.WrapperSkeleton>
              </Styles.ColumnSkeleton>
            </Styles.WrapperSkeleton>
          )}
        </Styles.ContentSkeleton>
      </Styles.Container>
    );
  }
};

export default withErrorBoundary(StudioPlansSkeleton, 'StudioPlansSkeleton');
